import { useCallback } from 'react';
import { useUserEmail } from '../../../../context/UserEmailContext';
import { useUserRole } from '../../../../context/UserRoleContext';
import { useUserPermissions } from '../../../../context/UserPermissionsContext';
import { useAdminAdviserMails } from '../../../../context/AdminAdviserEmailsContext';
import { getRelatedEmails } from '../../AML/Utils/getRelatedEmails';
import { collection, collectionGroup, doc, getDoc, getDocs, setDoc, runTransaction } from 'firebase/firestore';
import { auth, firestore, dbPensionCalculators } from '../../../../backend/firebaseconfig';
import { createClientStore } from './clientStore';

const store = createClientStore({ auth, resolveRelatedEmails: getRelatedEmails, portal: firestore, database: dbPensionCalculators, sdk: { collection, collectionGroup, doc, getDoc, getDocs, setDoc, runTransaction } });

// Compatibility wrapper for the existing dashboard/context; no HTTP service is used.
export async function clientRequest(path, options) {
  try { return await store.request(path, options); }
  catch (error) {
    if (error.code === 'permission-denied') throw new Error('Firebase denied access to client profiles. Please check your database permissions. No changes have been saved.');
    if (['unavailable', 'failed-precondition'].includes(error.code)) throw new Error('Client profiles are unavailable in Firebase. Please try again or contact support. No changes have been saved.');
    throw error;
  }
}
export function useClientRequest() {
  const { userEmail } = useUserEmail();
  const { userRole } = useUserRole();
  const { userPermissions = [] } = useUserPermissions();
  const { adminAdviserMails = [] } = useAdminAdviserMails();
  const request = useCallback((path, options = {}) => clientRequest(path, { ...options, session: { userEmail, userRole, userPermissions, linkedAdviserEmails: adminAdviserMails } }), [userEmail, userRole, userPermissions, adminAdviserMails]);
  return userEmail && userRole ? request : null;
}
export const dashboardPath = '/portal/tools-calculators/pension-calculators';
export const clientPath = (id, ownerEmail, calculator = 'tax-free-cash') => `${dashboardPath}/clients/${encodeURIComponent(ownerEmail)}/${encodeURIComponent(id)}/${calculator}`;
